import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPackDetailsListItemWidgetStyles = props => {
  var spacing = tokens.spacing;
  var noPadding = props.noPadding;
  return StyleSheet.create({
    container: Object.assign(Object.assign({}, !noPadding && {
      padding: spacing.SPACING_12,
      marginVertical: spacing.SPACING_4
    }), {
      flexDirection: 'row',
      backgroundColor: 'transparent',
      alignItems: 'center',
      justifyContent: 'space-between'
    }),
    innerContainer: {
      flexDirection: 'row',
      flex: 1,
      alignItems: 'flex-start'
    },
    planDetailsContainer: {
      flex: 1
    },
    rightContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: spacing.SPACING_8
    },
    icon: {
      marginRight: spacing.SPACING_8
    },
    imageBorderRadius: {
      borderRadius: tokens.borderRadius.BORDER_RADIUS_4
    },
    rightIcon: {
      marginLeft: spacing.SPACING_8
    },
    strikedText: {
      textDecorationLine: 'line-through',
      marginRight: spacing.SPACING_4
    },
    subTitle: {
      marginTop: spacing.SPACING_4
    },
    linkSubTitle: {
      marginTop: spacing.SPACING_4
    }
  });
};